import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'caret-down', 'CaretDown', [["path",{"d":"M6 10l6 6l6 -6h-12"}]]);